import React from "react";
import PdfViewer from "../../PdfViewer";

const SolicitudCamioneta = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/solicitud-camioneta.pdf`;
  /*const pdfUrl = "/pdf/solicitud-camioneta.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Solicitud Camioneta</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default SolicitudCamioneta;
